import React from "react";
import { SlidersHorizontal, KeyRound, ListTree, CheckCircle2, TrendingUp } from "lucide-react";

export const inputCls = "w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm";

export const AUTH_TYPES = [
    { value: "none", label: "None" },
    { value: "api_key_header", label: "API key (header)" },
    { value: "api_key_query", label: "API key (query)" },
    { value: "basic", label: "Basic" },
    { value: "bearer", label: "Bearer token" },
    { value: "oauth2_client_credentials", label: "OAuth2 client credentials" },
    { value: "custom_header", label: "Custom header" },
    { value: "sitecentric_client_key", label: "SiteCentric · client key" },
];

export const SITECENTRIC_AUTH = "sitecentric_client_key";

export const SECRET_SLOTS_FOR_AUTH = {
    none: [],
    api_key_header: ["api_key"],
    api_key_query: ["api_key"],
    basic: ["basic_username", "basic_password"],
    bearer: ["bearer_token"],
    oauth2_client_credentials: ["oauth_client_id", "oauth_client_secret"],
    custom_header: ["custom_header_name", "custom_header_value"],
    sitecentric_client_key: [],
};

export const STEPS = [
    { key: "general", label: "1 · General", icon: SlidersHorizontal },
    { key: "auth", label: "2 · Auth & Secrets", icon: KeyRound },
    { key: "endpoints", label: "3 · Endpoints", icon: ListTree },
    { key: "publish", label: "4 · Review & Publish", icon: CheckCircle2 },
    // Analytics step is only shown for published connections — the
    // wizard nav filters this out for drafts in ConnectionDetailPage.
    { key: "analytics", label: "5 · Analytics", icon: TrendingUp, publishedOnly: true },
];

export function StatusPill({ status }) {
    const map = {
        draft: "bg-white/5 border-white/15 text-white/70",
        testing: "bg-amber-300/10 border-amber-300/30 text-amber-200",
        published: "bg-emerald-300/10 border-emerald-300/30 text-emerald-200",
        retired: "bg-white/5 border-white/10 text-white/40",
        failed_validation: "bg-rose-300/10 border-rose-300/30 text-rose-200",
    };
    return (
        <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-mono border ${map[status] || map.draft}`}
            data-testid={`connection-status-${status}`}>
            {status}
        </span>
    );
}

export function Card({ title, children }) {
    return (
        <div className="border border-white/10 rounded-md p-3 bg-white/[0.02] text-xs space-y-1.5">
            <div className="text-[10px] uppercase tracking-wider text-white/40">{title}</div>
            {children}
        </div>
    );
}

export function Row({ k, v }) {
    return (
        <div className="flex justify-between gap-3">
            <span className="text-white/45">{k}</span>
            <span className="text-right">{v}</span>
        </div>
    );
}

export function Field({ label, required, hint, children }) {
    return (
        <label className="block">
            <div className="text-[11px] text-white/55 mb-1 flex items-center justify-between gap-2">
                <span>{label}{required && <span className="text-rose-400 ml-0.5">*</span>}</span>
                {hint && <span className="text-[10px] text-white/35 font-mono">{hint}</span>}
            </div>
            {children}
        </label>
    );
}

export function Toggle({ label, checked, onChange, testId }) {
    return (
        <label className="inline-flex items-center gap-2 text-xs cursor-pointer select-none">
            <input type="checkbox" checked={!!checked}
                onChange={(e) => onChange(e.target.checked)}
                data-testid={testId}
                className="accent-violet-400" />
            {label}
        </label>
    );
}

export function PreviewBlock({ title, data, testId }) {
    return (
        <div className="p-3 text-[11px]" data-testid={testId}>
            <div className="text-[10px] uppercase tracking-wider text-white/50 mb-1.5">{title}</div>
            <pre className="font-mono whitespace-pre-wrap break-all bg-black/40 border border-white/5 rounded p-2 max-h-72 overflow-auto">
                {data ? JSON.stringify(data, null, 2) : "(no data)"}
            </pre>
        </div>
    );
}
